import { render } from "./zcfzTable.vue?vue&type=template&id=68db808f&scoped=true"
import script from "./zcfzTable.vue?vue&type=script&lang=js"
export * from "./zcfzTable.vue?vue&type=script&lang=js"

import "./zcfzTable.vue?vue&type=style&index=0&id=68db808f&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68db808f"]])

export default __exports__